/* --------------------------------------------------------------------------------
 	*   execute_multiLevelPushMenu.METHOD({PARAMS});

	Erstellt das Mobil-Menu
	
	Diese Params koennen ueberschrieben werden, falls sie vom Default abweichen.
	PARAMS: 
		{	
			debug: false,
			this: '#mobilmenu', 
			containersToPush: ['#wrapper_page', '#pge_footer', '#pge_bottom'],
			backText: 'back',
			request_cuguserid: 0,
			cug_txt_logout: 'logout',
			navi_main_haslogin: 'false',
			requested_folderid: 'f0',
			requested_pageid: 'p0',
			arr_menu: null // JSON
			, arr_fixmenu: null // JSON
		}

	METHODS:
	* init
		- Erstellt das Mobil Menu
		Bsp.:
			execute_multiLevelPushMenu.init({PARAMS});
	  	Return: ---
----------------------------------------------------------------------------------- */
var execute_multiLevelPushMenu = (function () {
	"use strict"; // Preventing you from using undeclared variables. IE 9 will not throw an error even if it does not understand it.

	// --------------------------------------------------------------------------------
	//  *   Private Vars
	//  -------------------------------------------------------------------------------
	var params = {
		debug: false,
		this: '#mobilmenu', 
		containersToPush: ['#pge_header', '#pge_area', '#pge_container'],
		backText: 'back',
		request_cuguserid: 0,
		cug_txt_logout: 'logout',
		navi_main_haslogin: 'false',
		requested_folderid: 'f0',
		requested_pageid: 'p0',
		arr_menu: null, // JSON
		arr_fixmenu: null, // JSON
		arr_lang: null // JSON
	};

	var settings = $.extend({} ,params),
		debug = settings.debug,
		$this = null,
		$containersToPush = null;
	
	// --------------------------------------------------------------------------------
	//  *   Public Methods
	//  -------------------------------------------------------------------------------
	var init = function(params) {
		set_params(params);

		$.when( initialize() ).done(function( ) {
			if ($this != null && jQuery().multilevelpushmenu != undefined) {
				$this.show();

				$this.multilevelpushmenu({ 
					container: $this,
					menu : settings.arr_menu,
					containersToPush: [$containersToPush],
					mode: 'cover',
					backText: settings.backText,
					backItemClass: 'b_sub subback floatRight',
					backItemIcon: 'icon icon-angle-left',

					fullCollapse: true, // Menu starts closed
					collapsed: true, 
					preventItemClick: true,  //wird benötigt, damit Link-Klick funktioniert                                  
					preventGroupItemClick: true,   //wird benötigt, damit Link-Klick funktioniert 
					menuWidth: '100%',
					menuHeight: '0',
					swipe: 'desktop', // or 'touchscreen', or 'desktop'
				
					// ---------- * Click/touchstart menu item containing sub-items * --------------------
					onGroupItemClick: function() {
						// First argument is original event object
						var event = arguments[0],
							// Second argument is menu level object containing clicked item (<div> element)
							$menuLevelHolder = arguments[1],
							// Third argument is clicked item (<li> element)
							$item = arguments[2],
							// Fourth argument is instance settings/options object
							options = arguments[3];
					
						if ( arguments[0].currentTarget.className != "nofollow" ) {
							var itemHref  = $item.find( 'a:first' ).attr( 'href' );
							location.href = itemHref;

							arguments[0].stopPropagation();
							arguments[0].preventDefault();
						}
						else {
							window.scrollTo(0, 0);
						}
					},

					onItemClick: function() {
						// First argument is original event object
						var event = arguments[0],
							// Second argument is menu level object containing clicked item (<div> element)
							$menuLevelHolder = arguments[1],
							// Third argument is clicked item (<li> element)
							$item = arguments[2],
							// Fourth argument is instance settings/options object
							options = arguments[3];
					
						// Anchor href
						var itemHref = $item.find( 'a:first' ).attr( 'href' );
						// Redirecting the page
						location.href = itemHref;
					}
					// ---------- * end: Click/touchstart menu item containing sub-items * --------------------
				});
			}
		});
		
		// ========== * Mobile Menu schliessen * ======================================================================
		$( '#back_home' ).click(function(){
			menu_collapse(mobileMenu_containersToPush);
		});
					
		$( '#fullcollapse' ).click(function(){
			menu_collapse(mobileMenu_containersToPush);
		});

		$('#mobilmenu .close_menu').click(function() {
			menu_collapse(mobileMenu_containersToPush);
		});
		// ========== * end: Mobile Menu schliessen * ======================================================================

		// ========== * Mobile Menu toggle (open | close) * ======================================================================
		$( '.headermaster .cm-hamburger-icon button' ).click(function() {
			// console.log($('#pge_header button.navbar-toggle').data('status'));
			if ($('.headermaster .cm-hamburger-icon button').data('status') == 'collapsed') {
				$( '.headermaster .cm-hamburger-icon button' ).data( "status", "expanded" );
				menu_expand();
			}
			else {
				$( '.headermaster .cm-hamburger-icon button' ).data( "status", "collapsed" );
				menu_collapse();
			}
		});
		// ========== * end: Mobile Menu toggle (open | close) * ======================================================================
	};

	// --------------------------------------------------------------------------------
	//  *   Private Methods
	//  -------------------------------------------------------------------------------
	var set_params = function() {
		$.each(Array.prototype.slice.call(arguments), function(i, val) {
			if (typeof val == 'object' ) {
				settings = $.extend(params, val);
			}
			else {
				var key = 'param_'+i,
					obj = {};
					obj[val] = val;
					obj[key] = val;
				
				settings = $.extend(params, obj);
			}
		});
		debug = settings.debug;
	};

	var initialize = function() {
		$this = $(settings.this);
		$containersToPush = $(settings.containersToPush.join(", "));
	};

	var menu_collapse = function() {
		$( '.freeow' ).css( 'position', 'fixed' );
  
		$this.multilevelpushmenu('collapse');

		$( settings.this+', nav#mobilmenu_multilevelpushmenu' ).css({  
			'width'      : '100%',
			'min-width'  : '280px',
			'height'     : '0px',
			'min-height' : '0px'
		});
		
		$( '.headermaster .cm-hamburger-icon button' ).data( "status", "collapsed" );

		if ( $containersToPush.parent().is( 'div.multilevelpushmenu_overlay' ) ) {
			// console.log($containersToPush);
			$containersToPush.unwrap();
			$containersToPush.addClass('no-margin');
		}
	};

	var menu_expand = function() { 
		var clickEventType = (mobileCheck.init()) ? 'touchend' : 'click',
			is_logged_in = false,
			txt_logout 	 = '';

		if (settings.request_cuguserid > 0) {
			is_logged_in = true;
			txt_logout 	 = settings.cug_txt_logout;
		}
	
		$( settings.this+' .top.header' ).remove();

		var $div_topheader = $('<div />').attr( { 'class' : 'top header' } ).prependTo( 'div.levelHolderClass');

		// --------------------------------------------------------------------------------
		//  *   ACHTUNG:
		//  *   Diese Reihenfolge muss genauso eingehalten werden!
		//  *   Div1 = Login
		//  *   Div2 = Home
		//  *   Div2 = close Menu
		//  -------------------------------------------------------------------------------
		
		// ---------- * close Menu * --------------------
		var $div3 = $( '<div class="pull-right nofollow menu naviclose"><i class="bvcms-icon-close"></i></div>' ).appendTo( $div_topheader );
		$div3.bind( clickEventType , function(e) {
			menu_collapse();
			return false;
		});

		// ---------- * Home * --------------------
		var $div2 = $( '<div class="pull-right menu home"><a href="/"><i class="bvcms-icon-home"></i></a></div>' ).appendTo( $div_topheader );
		$div2.bind( clickEventType , function(e) {
			// execute HREF
		});

		if(settings.navi_main_haslogin.toLowerCase() == "false") {
			if (is_logged_in) {
				var $div1 = $( '<div class="pull-right menu login"><div style="text-align:center"><a href="/intern?cuguser_action=db_cuguser_logout"><i class="bvcms-icon-icon-login-user1"></i><p class="logout">'+settings.cug_txt_logout+'</p></a></div></div>' ).appendTo( $div_topheader );
				$div1.bind( clickEventType , function(e) {
					// execute HREF
				});
			}
		}
		else {
			// ---------- * Login * --------------------
			if (is_logged_in) {
				var $div1 = $( '<div class="pull-right menu login"><div style="text-align:center"><a href="/intern?cuguser_action=db_cuguser_logout"><i class="bvcms-icon-icon-login-user1"></i><p class="logout">'+settings.cug_txt_logout+'</p></a></div></div>' ).appendTo( $div_topheader );
				$div1.bind( clickEventType , function(e) {
					// execute HREF
				});
			}
			else {
				var $div1 = $( '<div class="pull-right menu login"><a href="/intern"><i class="bvcms-icon-icon-login-user1"></i><p>&nbsp;</p></a></div>' ).appendTo( $div_topheader );
				$div1.bind( clickEventType , function(e) {
					// execute HREF
				});	
			}	
		}

		// ========== * Language-Switch * ======================================================================
		if (settings.arr_lang != null && settings.arr_lang.length > 1) {
			var $div_lng  = $( '<div />' ).attr( { 'class' : 'pull-right menu lang' } ).appendTo( $div_topheader );
			if ( settings.arr_lang.length > 0 ) {
				$(settings.arr_lang).each( function(pos) {

					var v_link = '';
					if( settings.arr_lang[pos].hasOwnProperty('link') && settings.arr_lang[pos].link.length > 0) {
						v_link = settings.arr_lang[pos].link;
					}

					var	v_name = '';
					if( settings.arr_lang[pos].hasOwnProperty('shortname') && settings.arr_lang[pos].shortname.length > 0) {
						v_name = settings.arr_lang[pos].shortname;
					}

					var v_active = '';
					if( settings.arr_lang[pos].hasOwnProperty('is_active') && settings.arr_lang[pos].is_active) {
						v_active = 'active';
					}

					if (v_link != '' &&  v_name != ''){
						var divLng = $( '<div class="menu_lng '+ v_active+'"><a href="'+v_link+'" class="'+v_active+'">'+v_name+'</a></div>' ).appendTo( $div_lng );
							divLng.bind( clickEventType , function(e) {
							// execute HREF
						});
					}

				}); // end: loop $(settings.arr_lang).each(function(pos)
				
			} // end: if ( settings.arr_lang.length > 0 )
		} // end: if (settings.arr_lang != null && settings.arr_lang.length > 1)
			
		var $divClear = $( '<div class="clearfix" />').appendTo( $div_topheader );

		// ========== * Fix-Menu * ======================================================================
		if (settings.arr_fixmenu != null && settings.arr_fixmenu.length == 1) {
			var $div_fixmnu  = $( '<div />' ).attr( { 'class' : 'fix_mnu_box' } ).appendTo( $div_topheader );

			if ( settings.arr_fixmenu[0].hasOwnProperty('items') && settings.arr_fixmenu[0].items.length > 0 ) {
		 		for ( var key in settings.arr_fixmenu[0].items ) {
					// console.log(var_arr_fixmenu[0].items[key]);

					var v_link = '';
					if( settings.arr_fixmenu[0].items[key].hasOwnProperty('link') && settings.arr_fixmenu[0].items[key].link.length) {
						v_link = settings.arr_fixmenu[0].items[key].link;
					}

					var	v_name = '';
					if( settings.arr_fixmenu[0].items[key].hasOwnProperty('name') && settings.arr_fixmenu[0].items[key].name.length) {
						v_name = settings.arr_fixmenu[0].items[key].name;
					}

					if (v_link != '' &&  v_name != ''){
						var divFix = $( '<div class="menu_fix"><a href="'+v_link+'">'+v_name+'</a></div>' ).appendTo( $div_fixmnu );
						divFix.bind( clickEventType , function(e) {
							// execute HREF
						});
					}
				}
			}
		}
		// ========== * end: Fix-Menu * ======================================================================
		var $divClear = $( '<div class="clearfix" />').appendTo( $div_topheader );

		// ========== * Expand Menu-Level * ======================================================================
		execute_expand_level();
		
		// ========== * Menu-Groesse anpassen * ======================================================================
		$( settings.this+', nav#mobilmenu_multilevelpushmenu' ).css({  
			'width'      : '100%',
			'min-width'  : '280px',
			'height'     : '4000px',
			'min-height' : '4000px'
		});
	
		// ========== * Overlay einblenden * ======================================================================
		if ( $containersToPush.parent().is( 'div.multilevelpushmenu_overlay' ) ) {
			//nothing to do
		}
		else {
			$containersToPush.wrap( '<div class="multilevelpushmenu_overlay"></div>' );
		}
		// ========== * end: Overlay einblenden * ======================================================================
	};

	var execute_expand_level = function() { 
		var openMenuTitle_key = settings.requested_folderid;

		var $elm_menuitem = $this.find( 'li#'+settings.requested_folderid);
		if ( $this.find( 'li#'+settings.requested_pageid).length ) {
			$elm_menuitem = $this.find( 'li#'+settings.requested_pageid);
		}

		if ( $elm_menuitem.length ) {
			var active_item_class = $elm_menuitem.attr('class');
			// console.log('active_item_class');console.log(active_item_class);

			if ( active_item_class.length ) {
				var arr_active_item_class = active_item_class.split(/\s+/);
				// console.log('arr_active_item_class');console.log(arr_active_item_class);

				$.each(arr_active_item_class, function(i, key) {
					// console.log(i+') key = '+ key);
					if ( $this.multilevelpushmenu( 'findmenusbytitle', key ).length ) {
						openMenuTitle_key = key;
						return false;
					}
				});
			}
			// console.log('b) openMenuTitle_key = '+openMenuTitle_key);
		}

		var $openMenuLevel = $this.multilevelpushmenu( 'findmenusbytitle' , openMenuTitle_key );
		// console.log('$openMenuLevel');console.log($openMenuLevel);

		if( (typeof $openMenuLevel === "object") && ($openMenuLevel !== null) ) {
			$this.multilevelpushmenu( 'expand' , $openMenuLevel.first() );
		}
		else {
			// $this.multilevelpushmenu( 'expand' );
			$this.multilevelpushmenu( 'expand', $this.find('nav div:first'));
		}
	};


	// --------------------------------------------------------------------------------
	//  *   Public Methods API (Aufruf)
	//  -------------------------------------------------------------------------------
	return {
		init: init
	};
})( jQuery );